module.exports = __webpack_public_path__ + "static/media/polarbear.72cde669.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/polarbear.svg
// module id = 149
// module chunks = 0